import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-purchaseorderlineassign',
  templateUrl: './purchaseorderlineassign.component.html',
  styleUrls: ['./purchaseorderlineassign.component.css']
})
export class PurchaseorderlineassignComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
